import { offersWhiteColor, offersGreenColor } from "./../../variables";

export const buttonStyle = `
font-size: 18px;
font-weight: 700;
color: #879294;
padding: 12px 24px;
text-align: center;
min-width: 140px;
height: 55px;
border-radius: 4px;
border: solid 2px #979797;
background: transparent;

&:hover,
&:active,
&:focus {
    outline: none;
}`;

export const buttonGreenStyle = `
    border: none;
    box-shadow: inset 0 -3px 0 0 #15987e;
    color: ${offersWhiteColor};
    background: ${offersGreenColor};

    &[disabled] {
        box-shadow: inset 0 -4px 0 0 #cad1d4;
        background: #dde2e5;
        color: #879294;
    }
`;
